import React from "react";
import {  Button, Toolbar } from "react-admin";
import { Link } from "react-router-dom";
import KeyboardReturnIcon from "@material-ui/icons/KeyboardReturn";

const ShowToolBar = ({ basePath, ...props }) => {
  return (
    <Toolbar {...props}>
      <Button
        component={Link}
        to={basePath ? basePath : "/"}
        label="Back"
        style={{ margin: "0 auto 0 10px" }}
      >
        <KeyboardReturnIcon />
      </Button>
    </Toolbar>
  );
};

export default ShowToolBar;
